import React from "react";

import { Grid, Paper, Typography, makeStyles } from "@material-ui/core";

import { Panel } from "../../../panel";
import { TemplatePageProps, LayoutPage } from "../../../types";
import { addRegisteredLayout, PanelSettings } from "../layoutDescriptions";
import { ThemeProvider } from "@material-ui/core/styles";
import { TemplatePanel } from "@ploy-lib/types";
import { columnsSummaryHeaderTheme, useStyles, actionsTheme } from "./styles";
import clsx from "clsx";
import FormStatus from "../../../components/FormStatus";
import { useAppLoad } from "../../../appLoadContext";

export type ThreeColumnsWithCustomerSectionPanels = {
	customerInfo: TemplatePanel;
	column1: TemplatePanel;
	column2: TemplatePanel;
	column3: TemplatePanel;
	summaryHeader: TemplatePanel;
	actions: TemplatePanel;
};

export type ThreeColumnsWithCustomerSectionPanelKeys = keyof ThreeColumnsWithCustomerSectionPanels;
export type ThreeColumnsWithCustomerSectionPage = LayoutPage<
	ThreeColumnsWithCustomerSectionPanelKeys,
	ThreeColumnsWithCustomerSectionPanels
>;

type ThreeColumnsWithCustomerSectionPanelSettings = Record<ThreeColumnsWithCustomerSectionPanelKeys, PanelSettings>;

const customerInfoSettings: PanelSettings = {
	editableOptions: {
		title: false,
		elevation: true,
		square: true
	}
}

const column1PanelSettings: PanelSettings = {
	editableOptions: {
		title: true,
		elevation: true,
		square: true
	}
};
const column2PanelSettings: PanelSettings = {
	editableOptions: {
		title: true,
		elevation: true,
		square: true
	}
};
const column3PanelSettings: PanelSettings = {
	editableOptions: {
		title: true,
		elevation: true,
		square: true
	}
};

const summaryHeaderPanelSettings: PanelSettings = {
	editableOptions: {
		title: false,
		elevation: true,
		square: true,
	}
};

const actionsPanelSettings: PanelSettings = {
	editableOptions: {
		title: false,
		elevation: true,
		square: true,
	}
};

const panels: ThreeColumnsWithCustomerSectionPanelSettings = {
	summaryHeader: summaryHeaderPanelSettings,
	customerInfo: customerInfoSettings,
	column1: column1PanelSettings,
	column2: column2PanelSettings,
	column3: column3PanelSettings,
	actions: actionsPanelSettings
};

addRegisteredLayout({
	name: "ThreeColumnsWithCustomerSection",
	displayName: "ThreeColumnsWithCustomerSection",
	panels
});
const useThreeColumnsWithCustomerSectionStyle = makeStyles(theme => ({
	twoColumnPadding: {
		padding: 0
	}
}));

export function ThreeColumnsWithCustomerSection(props: TemplatePageProps<ThreeColumnsWithCustomerSectionPage>) {
	const classes = useStyles(props);
	const threeColumnsWithCustomerSectionStyle = useThreeColumnsWithCustomerSectionStyle(props);
	const { header, panels } = props;

	const { summaryHeader, customerInfo, column1, column2, column3, actions } =
		panels;

	const { vulcanContext } = useAppLoad();
	const sameHeight = {
		height: "100%"
	}
	return (
		<Grid container spacing={3}>
			
			<Grid item xs={12}>
				<FormStatus />
			</Grid>
			
			<Grid item xs={12} container >
				<Grid container spacing={3}>
					<Grid md={8} item>
						<Grid container spacing={3}>
							<Grid item md={6}>
								<div style={sameHeight}>
									<Grid item xs={12} style={sameHeight}>
										{column1 && (
											<Paper style={sameHeight}>
												{column1.panelTitle && (
													<Typography
														variant="h6"
														className={classes.mainSectionsHeader}
													>
														{column1.panelTitle}
													</Typography>
												)}
												<Panel
													className={clsx(
														classes.mainSections,
														threeColumnsWithCustomerSectionStyle.twoColumnPadding
													)}
													{...column1}
												/>
											</Paper>
										)}
									</Grid>
								</div>
							</Grid>
							<Grid item md={6}>
								<div style={sameHeight}>
									<Grid item xs={12} style={sameHeight}>
										{column2 && (
											<Paper style={sameHeight}>
												{column2.panelTitle && (
													<Typography
														variant="h6"
														className={classes.mainSectionsHeader}
													>
														{column2.panelTitle}
													</Typography>
												)}
												<Panel
													className={clsx(
														classes.mainSections,
														threeColumnsWithCustomerSectionStyle.twoColumnPadding
													)}
													elevation={0}
													{...column2}
												/>
											</Paper>
										)}
									</Grid>
								</div>
							</Grid>
							<Grid item md={12} xs={12}>
								{customerInfo && (
									<Paper >
										<Panel {...customerInfo} elevation={0}/>
								</Paper>)
								}
							</Grid>
						</Grid>
						
					</Grid>
					<Grid md={4} item>
						<Grid container spacing={3}>
								<Grid item xs={12}>
									{column3 && (
										<Paper>
											{column3.panelTitle && (
												<Typography
													variant="h6"
													className={classes.mainSectionsHeader}
												>
													{column3.panelTitle}
												</Typography>
											)}
											<Panel elevation={0}
												className={clsx(
													classes.mainSections,
													threeColumnsWithCustomerSectionStyle.twoColumnPadding
												)}
												{...column3}
											/>
											
										</Paper>
									)}
									
								</Grid>
								<Grid item xs={12}>
									{actions && vulcanContext !== "PostProcess" && (
										<ThemeProvider theme={actionsTheme}>
											<Panel elevation={0}
													className={clsx(
														classes.mainSections,
														threeColumnsWithCustomerSectionStyle.twoColumnPadding
													)}
												{...actions}
											/>
										</ThemeProvider>
									)}
								</Grid>
						</Grid>
					</Grid>
				</Grid>
					
					
				
			</Grid>
		</Grid>
	);
}

